import { createRouter, createWebHashHistory } from "vue-router";

//顶部
import layout from "@/layout/index.vue";

//目录
import list from "@/list/index.vue";

//首页
import home from "@/views/home/index.vue";

//资助教研公益项目
import fundingPublicWelfareProjects from "@/views/fundingPublicWelfareProjects/index.vue";

//图书介绍
// import bookIntro from "@/views/bookIntro/index.vue";

import highSchoolBooks from "@/views/bookIntro/highSchoolBooks/index.vue";

import middleSchoolBooks from "@/views/bookIntro/middleSchoolBooks/index.vue";

import primarySchoolBooks from "@/views/bookIntro/primarySchoolBooks/index.vue";

//增值服务
import addedServices from "@/views/addedServices/index.vue";
import booksDetails from "@/views/addedServices/booksDetails/index.vue";

//精品淘题
import boutiqueTaobaoQuestions from "@/views/boutiqueTaobaoQuestions/index.vue";
import topicSubjectDetails from "@/views/boutiqueTaobaoQuestions/topicSubjectDetails/index.vue";
import listenBig from "@/views/boutiqueTaobaoQuestions/listenBig/index.vue";

//教师助手
import teacherHand from "@/views/teacherHand/index.vue";
import cooperatePlate from "@/views/teacherHand/cooperatePlate/index.vue";
import research from "@/views/teacherHand/research/index.vue";
import teachingActivities from "@/views/teacherHand/teachingActivities/index.vue";
import projectAchievements from "@/views/teacherHand/projectAchievements/index.vue";
import projectAchievementsDetails from "@/views/teacherHand/projectAchievements/projectAchievementsDetails/index.vue";

import researchDetails from "@/views/teacherHand/research/researchDetails/index.vue";
import activityDetails from "@/views/teacherHand/teachingActivities/activityDetails/index.vue";

import collaborativeMediaDetails from "@/views/teacherHand/components/collaborativeMediaDetails/index.vue";
import thisEventRegistrationTeacher from "@/views/teacherHand/components/thisEventRegistrationTeacher/index.vue";
import bookDonation from "@/views/teacherHand/components/bookDonation/index.vue";

//学生天地
import studentWorld from "@/views/studentWorld/index.vue";
import studentWorldList from "@/views/studentWorld/studentWorldList/index.vue";

import KnowledgeDrivenGoods from "@/views/studentWorld/KnowledgeDrivenGoods/index.vue";
import onlineLearning from "@/views/studentWorld/onlineLearning/index.vue";
import thematicActivities from "@/views/studentWorld/thematicActivities/index.vue";
import worksDisplay from "@/views/studentWorld/worksDisplay/index.vue";

import KnowledgeDetails from "@/views/studentWorld/KnowledgeDrivenGoods/KnowledgeDetails/index.vue";
import onlineDetails from "@/views/studentWorld/onlineLearning/onlineDetails/index.vue";
import thematicDetails from "@/views/studentWorld/thematicActivities/thematicDetails/index.vue";
import worksDisplayDetails from "@/views/studentWorld/worksDisplay/worksDisplayDetails/index.vue";

import thisEventRegistrationStudent from "@/views/studentWorld/components/thisEventRegistrationStudent/index.vue";

//家长学堂
import parentSchool from "@/views/parentSchool/index.vue";

import talkPolicies from "@/views/parentSchool/talkPolicies/index.vue";
import checkTheProcess from "@/views/parentSchool/checkTheProcess/index.vue";
import checkTheProcessList from "@/views/parentSchool/checkTheProcess/checkTheProcessList/index.vue";

import fractionBar from "@/views/parentSchool/fractionBar/index.vue";
import findAUniversity from "@/views/parentSchool/findAUniversity/index.vue";
import parentChildGarden from "@/views/parentSchool/parentChildGarden/index.vue";

import talkPoliciesDetails from "@/views/parentSchool/talkPolicies/talkPoliciesDetails/index.vue";
import checkTheProcessDetails from "@/views/parentSchool/checkTheProcess/checkTheProcessDetails/index.vue";
import findAUniversityDetails from "@/views/parentSchool/findAUniversity/findAUniversityDetails/index.vue";
import parentChildGardenDetails from "@/views/parentSchool/parentChildGarden/parentChildGardenDetails/index.vue";

//经销授权
import authorizedOnlineShop from "@/views/distributionAuthorization/authorizedOnlineShop/index.vue";
import offlineAgent from "@/views/distributionAuthorization/offlineAgent/index.vue";

import applicationProcess from "@/views/distributionAuthorization/authorizedOnlineShop/applicationProcess/index.vue";

import onlineShopDetails from "@/views/distributionAuthorization/authorizedOnlineShop/onlineShopDetails/index.vue";

import queryProgressStep from "@/views/distributionAuthorization/authorizedOnlineShop/queryProgressStep/index.vue";

// 申请授权
import progressStep from "@/views/distributionAuthorization/authorizedOnlineShop/progressStep/index.vue";

//关于我们
import walkIntroTianLi from "@/views/walkIntroTianLi/index.vue";

import joinUsDetails from "@/views/walkIntroTianLi/components/joinUsDetails/index.vue";
import enterpriseDetails from "@/views/walkIntroTianLi/components/enterpriseDetails/index.vue";

//个人中心  ————个人信息————我的图书————我的下载————个人收藏————我的活动————站内通知
import personalCenter from "@/views/personalCenter/index.vue";
import personalInfor from "@/views/personalCenter/personalInfor/index.vue";
import myBook from "@/views/personalCenter/myBook/index.vue";
import myDownloads from "@/views/personalCenter/myDownloads/index.vue";
import myCollection from "@/views/personalCenter/myCollection/index.vue";
import myActivity from "@/views/personalCenter/myActivity/index.vue";
import myNotifications from "@/views/personalCenter/myNotifications/index.vue";
import notificationsDetails from "@/views/personalCenter/myNotifications/notificationsDetails/index.vue";

import myActivityDetails from "@/views/personalCenter/myActivity/myActivityDetails/index.vue";

//登录页面
import login from "@/views/login/index.vue";

import nowLogin from "@/views/login/nowLogin/index.vue";

import retrievePasswordLogin from "@/views/login/retrievePasswordLogin/index.vue";

import newPassword from "@/views/login/newPassword/index.vue";

import QRCodeLogin from "@/views/login/QRCodeLogin/index.vue";

//隐私政策 privacyAgreement
import privacyAgreement from "@/views/privacyAgreement/index.vue";

//注册页面
import loginRegister from "@/views/loginRegister/index.vue";

//图书纠错
import bookCorrection from "@/views/bookCorrection/index.vue";

//正版验证
import testAndVerify from "@/views/testAndVerify/index.vue";

const routes = [
  /* 登录页面 */
  {
    path: "/login",
    component: login,
    meta: { title: "登录-天利38套考试研究网" },
    children: [
      {
        path: "nowLogin",
        component: nowLogin,
        meta: { title: "登录-天利38套考试研究网" },
      },
      {
        path: "retrievePasswordLogin",
        component: retrievePasswordLogin,
        meta: { title: "重置密码-天利38套考试研究网" },
      },
      {
        path: "newPassword",
        component: newPassword,
        meta: { title: "重置密码-天利38套考试研究网" },
      },
      {
        path: "QRCodeLogin",
        component: QRCodeLogin,
      },
    ],
  },

  /* 注册页面  */
  {
    path: "/loginRegister",
    component: loginRegister,
    meta: { title: "注册-天利38套考试研究网" },
  },

  // 微信登录
  {
    path: "/wechat",
    component:()=>import("@/views/wechat/index.vue"),
    meta: { title: "注册-天利38套考试研究网" },
  },
  {
    path: "/layout",
    component: layout,
    children: [
      {
        path: "list",
        component: list,
        children: [
          {
            path: "home",
            component: home,
            meta: { title: "天利38套考试研究网-专注考试研究，汇集考试资源。" },
          },
          {
            path: "fundingPublicWelfareProjects",
            // component:()=>import("@/views/fundingPublicWelfareProjects/index.vue"),
            component:fundingPublicWelfareProjects,
            meta: { title: "天利38套考试研究网-专注考试研究，汇集考试资源。" },
          },
          /*图书介绍————高中书系——初中书系——小学书系 */
          {
            path: "highSchoolBooks",
            component: highSchoolBooks,
            meta: { title: "高中书系-图书介绍-天利38套考试研究网" },
          },
          {
            path: "middleSchoolBooks",
            component: middleSchoolBooks,
            meta: { title: "初中书系-图书介绍-天利38套考试研究网" },
          },
          {
            path: "primarySchoolBooks",
            component: primarySchoolBooks,
            meta: { title: "小学书系-图书介绍-天利38套考试研究网" },
          },

          /*增值服务 */
          {
            path: "addedServices",
            component: addedServices,
            meta: { title: "增值服务-天利38套考试研究网" },
          },
          {
            path: "booksDetails",
            component: booksDetails,
          },

          /*精品淘题 */
          {
            path: "boutiqueTaobaoQuestions",
            component: boutiqueTaobaoQuestions,
            meta: { title: "精品淘题-天利38套考试研究网" },
          },
          {
            path: "topicSubjectDetails",
            component: topicSubjectDetails,
          },
          {
            path: "listenBig",
            component: listenBig,
            meta: { title: "高级搜索-精品淘题-天利38套考试研究网" },
          },

          /*教师助手——合作平台———课题研究——教研活动——综合页面 */
          {
            path: "teacherHand",
            component: teacherHand,
            meta: { title: "教师助手-天利38套考试研究网" },
          },
          //合作平台
          {
            path: "cooperatePlate",
            component: cooperatePlate,
            meta: { title: "合作平台-教师助手-天利38套考试研究网" },
          },
          {
            path: "research",
            component: research,
            meta: { title: "课题研究-教师助手-天利38套考试研究网" },
          },
          {
            path: "teachingActivities",
            component: teachingActivities,
            meta: { title: "教研活动-教师助手-天利38套考试研究网" },
          },
          {
            path: "projectAchievements",
            component: projectAchievements,
            meta: { title: "研究成果-教师助手-天利38套考试研究网" },
          },
          {
            path: "projectAchievementsDetails",
            component: projectAchievementsDetails,
          },

          //详情
          {
            path: "researchDetails",
            component: researchDetails,
          },
          {
            path: "activityDetails",
            component: activityDetails,
          },
          {
            path: "collaborativeMediaDetails",
            component: collaborativeMediaDetails,
          },
          //活动报名——教师
          {
            path: "thisEventRegistrationTeacher",
            component: thisEventRegistrationTeacher,
            meta: { title: "活动报名-教师助手-天利38套考试研究网" },
          },
          //图书捐赠活动
          {
            path: "bookDonation",
            component: bookDonation,
            meta: { title: "图书捐赠-教师助手-天利38套考试研究网" },
          },

          /*学生天地————知识干货——在线学习——专题活动——作品展示 */
          {
            path: "studentWorld",
            component: studentWorld,
            meta: { title: "学生天地-天利38套考试研究网" },
          },
          {
            path: "studentWorldList",
            component: studentWorldList,
            meta: { title: "搜索列表-学生天地-天利38套考试研究网" },
          },
          {
            path: "KnowledgeDrivenGoods",
            component: KnowledgeDrivenGoods,
            meta: { title: "知识干货-学生天地-天利38套考试研究网" },
          },
          {
            path: "onlineLearning",
            component: onlineLearning,
            meta: { title: "在线学习-学生天地-天利38套考试研究网" },
          },
          {
            path: "thematicActivities",
            component: thematicActivities,
            meta: { title: "专题活动-学生天地-天利38套考试研究网" },
          },
          {
            path: "worksDisplay",
            component: worksDisplay,
            meta: { title: "作品展示-学生天地-天利38套考试研究网" },
          },
          //详情
          {
            path: "KnowledgeDetails",
            component: KnowledgeDetails,
          },
          {
            path: "onlineDetails",
            component: onlineDetails,
          },
          {
            path: "thematicDetails",
            component: thematicDetails,
          },
          {
            path: "worksDisplayDetails",
            component: worksDisplayDetails,
          },
          {
            path: "thisEventRegistrationStudent",
            component: thisEventRegistrationStudent,
            meta: { title: "活动报名-学生天地-天利38套考试研究网" },
          },
          /*家长学堂————说政策———看流程——分数线——找大学——亲子园地 */
          {
            path: "parentSchool",
            component: parentSchool,
            meta: { title: "家长学堂-天利38套考试研究网" },
          },
          {
            path: "talkPolicies",
            component: talkPolicies,
            meta: { title: "说政策-家长学堂-天利38套考试研究网" },
          },
          {
            path: "checkTheProcess",
            component: checkTheProcess,
            meta: { title: "看流程-家长学堂-天利38套考试研究网" },
          },
          {
            path: "checkTheProcessList",
            component: checkTheProcessList,
            meta: { title: "搜索列表-看流程-家长学堂-天利38套考试研究网" },
          },
          {
            path: "fractionBar",
            component: fractionBar,
            meta: { title: "分数线-家长学堂-天利38套考试研究网" },
          },
          {
            path: "findAUniversity",
            component: findAUniversity,
            meta: { title: "找大学-家长学堂-天利38套考试研究网" },
          },
          {
            path: "parentChildGarden",
            component: parentChildGarden,
            meta: { title: "亲子园地-家长学堂-天利38套考试研究网" },
          },
          //详情
          {
            path: "talkPoliciesDetails",
            component: talkPoliciesDetails,
          },
          {
            path: "checkTheProcessDetails",
            component: checkTheProcessDetails,
          },
          {
            path: "findAUniversityDetails",
            component: findAUniversityDetails,
          },
          {
            path: "parentChildGardenDetails",
            component: parentChildGardenDetails,
          },

          /*经销授权————授权网店——线下代理 */
          {
            path: "authorizedOnlineShop",
            component: authorizedOnlineShop,
            meta: { title: "授权网店-天利38套考试研究网" },
          },
          {
            path: "offlineAgent",
            component: offlineAgent,
            meta: { title: "线下代理-天利38套考试研究网" },
          },
          {
            path: "applicationProcess",
            component: applicationProcess,
            meta: { title: "申请流程-天利38套考试研究网" },
          },
          //详情
          {
            path: "onlineShopDetails",
            component: onlineShopDetails,
          },

          //输入框步骤查询
          {
            path: "queryProgressStep",
            component: queryProgressStep,
            meta: { title: "查询进度-天利38套考试研究网" },
          },

          //申请授权
          {
            path: "progressStep",
            component: progressStep,
            meta: { title: "申请授权-天利38套考试研究网" },
          },

          /*关于我们 */
          {
            path: "walkIntroTianLi",
            component: walkIntroTianLi,
            meta: { title: "关于我们-天利38套考试研究网" },
          },
          //详情
          {
            path: "enterpriseDetails",
            component: enterpriseDetails,
          },
          {
            path: "joinUsDetails",
            component: joinUsDetails,
          },

          /* 个人中心 */
          {
            path: "personalCenter",
            component: personalCenter,
            meta: { title: "个人中心-天利38套考试研究网" },
          },

          {
            path: "personalInfor",
            component: personalInfor, //个人信息
            meta: { title: "个人信息-个人中心-天利38套考试研究网" },
          },
          {
            path: "myBook",
            component: myBook, //我的图书
            meta: { title: "我的图书-个人中心-天利38套考试研究网" },
          },
          {
            path: "myDownloads",
            component: myDownloads, //我的下载
            meta: { title: "我的下载-个人中心-天利38套考试研究网" },
          },
          {
            path: "myCollection",
            component: myCollection, //我的收藏
            meta: { title: "我的收藏-个人中心-天利38套考试研究网" },
          },
          {
            path: "myActivity",
            component: myActivity, //我的活动
            meta: { title: "我的活动-个人中心-天利38套考试研究网" },
          },
          {
            path: "myNotifications",
            component: myNotifications, //站内通知
            meta: { title: "站内通知-个人中心-天利38套考试研究网" },
          },

          // //我的活动—————详情
          // {
          //   path: "activityDetails",
          //   component: activityDetails,
          // },

          //个人中心————站内通知————详情
          {
            path: "notificationsDetails",
            component: notificationsDetails,
          },

          //个人中心————我的活动—————详情
          {
            path: "myActivityDetails",
            component: myActivityDetails,
          },

          //隐私政策
          {
            path: "privacyAgreement",
            component: privacyAgreement,
          },

          //图书反馈
          {
            path: "bookCorrection",
            component: bookCorrection,
            meta: { title: "图书反馈-天利38套考试研究网" },
          },

          //正版验证
          {
            path: "testAndVerify",
            component: testAndVerify,
            meta: { title: "正版验证-天利38套考试研究网" },
          },
        ],
      },
    ],
  },
  // 如果没有路径的话，那么重定向到首页
  {
    path: "/",
    redirect: "/layout/list/home",
  },

  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 丝滑地滚动到顶部
    return { top: 0, behavior: "smooth" };
  },
});

//路由拦截---暂时注释
// router.beforeEach((to, from, next) => {
//   // console.log(to, from);
//   //如果已经登录
//   if (localStorage.getItem("userInfo")) {
//     if (to.path === "/login/nowLogin") {
//       next({
//         path: "/layout/list/home",
//       });
//     } else {
//       next();
//     }
//   }
//   // 如果没有登录
//   else {
//     if (to.path !== "/login/nowLogin") {
//       next({
//         path: "/login/nowLogin",
//       });
//     } else {
//       next();
//     }
//   }
// });

// 改变网站地址
function changeWebUrl(route) {
  if (process.env.NODE_ENV === "development") {
    return;
  }
  let pcOrigin = 'https://www.tl100.com'
  let appOrigin = 'https://mobile.tl100.com'
  // 如果是手机端宽度
  if (window.document.documentElement.clientWidth<600) {
    // 如果当前网址不是手机端网址，那么就跳转到手机端网址
    if (window.location.origin !== appOrigin) {
      window.location.href = appOrigin + "/#" + route.fullPath;
    }
  }
  // 如果是电脑端宽度
  else{
    // 如果当前网址不是电脑端网址，那么就跳转到电脑端网址
    if (window.location.origin!==pcOrigin) {
      window.location.href = pcOrigin + "/#"+ route.fullPath
    }
  }
}




// 路由记录表，记录第几次进入了这个页面地址
let routerRecord = JSON.parse(localStorage.getItem("routerRecord")) ?? {};

let excludeArr = [
  "/",
  "/login/nowLogin",
  "/login/retrievePasswordLogin",
  "/login/newPassword",
  "/loginRegister",
];
router.beforeEach((to, from, next) => {
   // 调用函数-改变网站地址
  changeWebUrl(to);

  if (to.path === "/login/nowLogin" && !excludeArr.includes(from.path)) {
    localStorage.setItem("loginBack", from.fullPath);
  }

  // 如果对象里面存在这个属性
  if (Object.prototype.hasOwnProperty.call(routerRecord, to.path)) {
    routerRecord[to.path] = routerRecord[to.path] + 1;
  } else {
    routerRecord[to.path] = 1;
  }
  localStorage.setItem("routerRecord", JSON.stringify(routerRecord));

  next();
});

window.addEventListener("beforeunload", () => {
  localStorage.removeItem("routerRecord");
});

export default router;
